export const getFirstAndLastItem = (arr: string[]): string[] => {
  return arr.length > 2 ? [arr[0], arr[arr.length - 1]] : arr
}

export const removeDuplicate = (array: any[]): any[] =>
  Array.from(new Set(array))

export const joinWithConjunction = (
  arr: string[],
  conjunction = 'dan'
): string => {
  if (!Array.isArray(arr)) return ''
  const len = arr.length

  if (len === 0) return ''
  if (len === 1) return arr[0]
  if (len === 2) return arr.join(` ${conjunction} `)

  return arr.slice(0, -1).join(', ') + ` ${conjunction} ` + arr[len - 1]
}
